import { customerApi } from "../../../utils/apiConfig";

const getAuthHeaders = () => {
  const token = sessionStorage.getItem("token");

  return {
    Authorization: token ? `Bearer ${token}` : "",
  };
};

export const compareInvoiceDocumentsApi = (
  invoicePdf,
  excelFile,
  commercialInvoicePdf,
  options = {}
) => {
  if (!invoicePdf) {
    throw new Error("E-Fatura PDF dosyası zorunludur.");
  }

  if (!excelFile) {
    throw new Error("Excel dosyası zorunludur.");
  }

  if (!commercialInvoicePdf) {
    throw new Error("Commercial Invoice PDF dosyası zorunludur.");
  }

  const { debug = false, onUploadProgress } = options;

  const formData = new FormData();

  formData.append("invoicePdf", invoicePdf);
  formData.append("excelFile", excelFile);
  formData.append("commercialInvoicePdf", commercialInvoicePdf);

  return customerApi.post("/muhasebe-ocr/e-arsiv-karsilastir", formData, {
    headers: getAuthHeaders(),
    params: {
      debug: debug ? 1 : 0,
    },
    onUploadProgress,
  });
};

export const compareEArchiveInvoiceWithExcelApi = compareInvoiceDocumentsApi;
